import { HttpClient } from '@angular/common/http';
import { AuthService } from "./auth/auth.service";
import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";

import { ILogin } from "../model/top.model";
import { ENV } from '@app/env';

@Injectable()
export class Login {
  apiUrl: string = ENV.apiUrl;
  appVersion: string;

  constructor(
    public http: HttpClient,
    public storage: Storage,
    private authService: AuthService
  ) {
    this.appVersion = this.authService.appVersion;
  }

  login(username, password): Promise<Partial<ILogin>> {
    return new Promise((resolve) => {
      this.authService.login(username, password, null).subscribe(
        (login) => {
          this.authService.setAuthorizationLogin(login).then(() => {
            resolve(login);
          });
        },
        (error) => {
          resolve(error);
        }
      );
    });
  }

  /**
   * Helper method to make a unique clone of an object
   */
  cloneObject(obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.cloneObject(obj[i]);
      }
      return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = this.cloneObject(obj[attr]);
      }
      return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
  }
}



// WEBPACK FOOTER //
// ./src/providers/login.ts